import { ComponentType } from 'react';

import withLocalhostAuthenticator from './withLocalhostAuthenticator';
import withCookieAuthenticator from './withCookieAuthenticator';
import { CookieAuth, LocalhostAuth } from '../auth';
import { Environment } from '../types';
import { isDevMode } from '../utils/envConfig';

type WithAuthenticatorOptions = {
  env: Environment;
};

const withAuthenticator = <T extends object>(
  Component: ComponentType<T>,
  options: WithAuthenticatorOptions
) => {
  return isDevMode
    ? withLocalhostAuthenticator(Component, LocalhostAuth)
    : withCookieAuthenticator(Component, CookieAuth, { env: options.env });
};

export default withAuthenticator;
